import React from 'react';
import { KiteIcon } from '@kite/react-kite';
import './VideoPlayer.scss';
import { getVideoId } from '../../shared/getVideoId';

export interface VideoPlayerProps {
    videoUrl: string;
    setVideoOpen: any;
}

export interface VideoPlayerTitleProps {
    videoTitle: string;
    setVideoTitle: any;
}

type AllVideoProps = VideoPlayerProps & VideoPlayerTitleProps;

export const VideoPlayer = (props: AllVideoProps) => {
    return (
        <section aria-modal={true} className="video-player themed-container">
            <div className="video-container">
                <iframe
                    src={`https://player.vimeo.com/video/${getVideoId(
                        props.videoUrl
                    )}?title=true`}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    title={props.videoTitle}
                ></iframe>
                <button
                    className="close-button"
                    aria-label="Close modal"
                    onClick={() => {
                        props.setVideoOpen(null);
                        props.setVideoTitle(null);
                    }}
                >
                    <KiteIcon icon="ki-x" size="2rem" />
                </button>
            </div>
        </section>
    );
};
